"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AccessoryFeaturesListComponent = function AccessoryFeaturesListComponent(_ref) {
  var accessory = _ref.accessory;
  var dictionary = (0, _reactRedux.useSelector)(function (state) {
    return state.dictionary;
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h3", null, accessory.title || 'Product'), accessory.benefits.length > 0 && /*#__PURE__*/_react["default"].createElement("ul", {
    className: "tab__content__section__row__description__list"
  }, accessory.benefits.map(function (benefit, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index
    }, benefit.title);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-link"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "fake-link"
  }, dictionary.readMore, " "), /*#__PURE__*/_react["default"].createElement("span", {
    className: "pep-arrow"
  }, "\uEB4B")));
};

var _default = AccessoryFeaturesListComponent;
exports["default"] = _default;